import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { InitProvider } from "./init-provider";
import { AuthService } from "./Services/Auth/auth.service";
import { FaviconService } from "./Services/favicon.service";
import { WebPageService } from "./Services/webpage.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  constructor(
    public router: Router,
    public translateProvider: TranslateService,
    public initProvider: InitProvider,
    public authService: AuthService,
    public favicon: FaviconService,
    private webPageService: WebPageService
  ) {
    const company = initProvider.getSettings();
    if (company.favicon) {
      console.log("favi", company.favicon.medium);

      favicon.set(company.favicon.medium);
    }
    document.documentElement.style.setProperty(
      "--primary-color",
      company.color_1
    );
    document.documentElement.style.setProperty(
      "--secondary-color",
      company.color_2
    );
    document.documentElement.style.setProperty("--info-color", company.color_3);
    document.documentElement.style.setProperty(
      "--extra-color",
      company.color_4
    );
    document.documentElement.style.setProperty(
      "--info-font-color",
      company.color_5
    );
    document.documentElement.style.setProperty(
      "--primary-color-darken",
      this.lightenDarkenColor(company.color_1, -20)
    );
    document.documentElement.style.setProperty(
      "--secondary-color-darken",
      this.lightenDarkenColor(company.color_2, -20)
    );
    document.documentElement.style.setProperty(
      "--info-color-darken",
      this.lightenDarkenColor(company.color_3, -20)
    );

    // Button/link colors default to the current theme so nothing breaks before
    // (or when) the web-page `general` colors are available.
    this.setButtonLinkColors(company.color_3, company.color_5, company.color_3);

    this.translateProvider.setDefaultLang("en");
    if (authService.user) this.translateProvider.use(authService.user.language);
    else this.translateProvider.use(company.language);
  }

  ngOnInit() {
    this.applyGeneralColors();
  }

  /**
   * Pull the button/link colors from the public web-page `general` object and
   * expose them as CSS variables so every button and link across the app can
   * use them. Falls back to the current theme when a color isn't configured.
   */
  private async applyGeneralColors(): Promise<void> {
    const company = this.initProvider.getSettings();
    try {
      const res = await this.webPageService.getWebPage();
      const general = res?.data?.general || {};
      this.setButtonLinkColors(
        general.button_color || company.color_3,
        general.button_text_color || company.color_5,
        general.link_color || company.color_3
      );
    } catch {
      /* keep the theme defaults already set in the constructor */
    }
  }

  private setButtonLinkColors(button: string, buttonText: string, link: string): void {
    const root = document.documentElement.style;
    root.setProperty("--button-color", button);
    root.setProperty("--button-text-color", buttonText);
    root.setProperty("--button-color-darken", this.lightenDarkenColor(button, -20));
    root.setProperty("--link-color", link);
  }

  lightenDarkenColor(col, amt) {
    let usePound = false;

    if (col[0] === "#") {
      col = col.slice(1);
      usePound = true;
    }

    const num = parseInt(col, 16);

    let r = (num >> 16) + amt;

    if (r > 255) {
      r = 255;
    } else if (r < 0) {
      r = 0;
    }

    let b = ((num >> 8) & 0x00ff) + amt;

    if (b > 255) {
      b = 255;
    } else if (b < 0) {
      b = 0;
    }

    let g = (num & 0x0000ff) + amt;

    if (g > 255) {
      g = 255;
    } else if (g < 0) {
      g = 0;
    }

    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
  }
}
